export const GET_USER = 'GET_USER'
export const GET_USER_ERR = 'GET_USER_ERR'

export const ADD_USER = 'ADD_USER'
export const ADD_USER_ERR = 'ADD_USER_ERR'

//
export const EDIT_USER = 'EDIT_USER'
export const EDIT_USER_ERR = 'EDIT_USER_ERR'

export const DELETE_USER = 'DELETE_USER'
export const DELETE_USER_ERR = 'DELETE_USER_ERR'